import React from 'react';
import { Button as MuiButton } from '@mui/material';

interface ButtonProps {
  onClick: () => void;
  children: React.ReactNode;
  variant?: 'primary' | 'secondary';
  disabled?: boolean;
}

const Button = ({ 
  onClick, 
  children, 
  variant = 'primary',
  disabled = false 
}: ButtonProps) => {
  const styles = {
    primary: {
      backgroundColor: "#1976d2",
      color: "white",
      "&:hover": {
        backgroundColor: "#d45500"
      }
    },
    secondary: {
      color: "#666"
    }
  };

  return (
    <MuiButton
      onClick={onClick}
      disabled={disabled}
      sx={styles[variant]}
    >
      {children}
    </MuiButton>
  );
};

export default Button; 